<template>
  <div>
    <div class="absolute-center" v-if="!goodsIsLoaded">
      <spinner></spinner>
    </div>
    <div v-else class="content-with-navbar-holder">
      <navbar ref="navbar" />
      <v-content>
        <v-container class="bg-panel">
          <v-tabs
            v-model="currentTab"
            dark
            slider-color="yellow"
            :class="{ 'no-arc-docs': !arcDocsSupport }"
          >
            <v-tab :key="0" ripple>
              <div class="tab-bookmark d-flex align-items-center">
                {{ docListTexts.listInWork }}
              </div>
            </v-tab>
            <v-tab :key="1" ripple>
              <div class="tab-bookmark d-flex align-items-center">
                {{ docListTexts.listArchive }}
              </div>
            </v-tab>

            <v-tabs-items touchless>
              <v-tab-item :key="0">
                <v-container>
                  <div class="d-flex flex-column flex-md-row">
                    <div
                      class="d-flex overflow-hidden align-items-center py-3 py-md-0"
                    >
                      <h3
                        class="align-center d-inline-flex day-date-title lh-1"
                      >
                        {{ docListTexts.listFor }} :
                      </h3>

                      <template>
                        <div class="a-lh-1 d-flex">
                          <v-menu>
                            <template #activator="{ on: menu }">
                              <a href="#" v-on="{ ...menu }">{{
                                selectedPeriod
                              }}</a>
                            </template>
                            <v-list>
                              <v-list-tile
                                v-for="(item, index) in periods"
                                :key="index"
                                @click="setPeriod(item.val)"
                                v-bind:class="[item.val === -1 ? 'hr' : '']"
                              >
                                <v-list-tile-title>{{
                                  item.title
                                }}</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>

                      <div class="datepicker-holder px-0 px-md-2">
                        <period-picker
                          v-if="periodSelecting"
                          :from="periodFrom"
                          :to="periodTo"
                          @done="periodSelect"
                        />
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="action-panel d-flex flex-grow-0">
                      <div class="input-holder d-flex search-holder">
                        <v-text-field
                          :label="docListTexts.searchLabel"
                          v-model="docSearchValue"
                          @keyup.enter="searchByNumber"
                        ></v-text-field>
                      </div>

                      <v-btn @click="refreshList" :icon="true"><i class="material-icons">refresh</i></v-btn>
                    </div>
                  </div>
                </v-container>
                <v-data-table
                  :headers="headers"
                  :items="docList"
                  :rows-per-page-items="rowsPerPage"
                  class="elevation-1 w-100"
                  ref="dataTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr @click="openDoc(props.item.id)" :key="props.item.id">
                      <td class="text-xs-center">
                        {{ props.item.docDateTime | formatDateTime }}
                      </td>
                      <td class="text-xs-center">{{ props.item.docNum }}</td>
                      <td class="text-xs-left">{{ props.item.clientName }}</td>
                      <td class="text-xs-left">
                        {{ props.item.automobileName }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div v-if="noDocuments && docsLoaded">
                      <h3 class="text-center">{{ $t('docList.noDocs') }}</h3>
                    </div>
                    <div v-else>
                      <spinner></spinner>
                    </div>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-container>
                  <div class="d-flex flex-column flex-md-row">
                    <div
                      class="d-flex overflow-hidden align-items-center py-3 py-md-0"
                    >
                      <h3
                        class="align-center d-inline-flex day-date-title lh-1"
                      >
                        {{ docListTexts.listFor }} :
                      </h3>

                      <template>
                        <div class="a-lh-1 d-flex">
                          <v-menu>
                            <template #activator="{ on: menu }">
                              <a href="#" v-on="{ ...menu }">{{
                                selectedPeriod
                              }}</a>
                            </template>
                            <v-list>
                              <v-list-tile
                                v-for="(item, index) in periods"
                                :key="index"
                                @click="setPeriod(item.val)"
                                v-bind:class="[item.val === -1 ? 'hr' : '']"
                              >
                                <v-list-tile-title>{{
                                  item.title
                                }}</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>

                      <div class="datepicker-holder px-0 px-md-2">
                        <period-picker
                          v-if="periodSelecting"
                          :from="periodFrom"
                          :to="periodTo"
                          @done="periodSelect"
                        />
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="action-panel d-flex flex-grow-0">
                      <div class="input-holder d-flex search-holder">
                        <v-text-field
                          :label="docListTexts.searchLabel"
                          v-model="docSearchValue"
                          @keyup.enter="searchByNumber"
                        ></v-text-field>
                      </div>

                      <v-btn @click="refreshList" :icon="true"><i class="material-icons">refresh</i></v-btn>
                    </div>
                  </div>
                </v-container>
                <v-data-table
                  :headers="headers"
                  :items="docListArchived"
                  :rows-per-page-items="rowsPerPage"
                  class="elevation-1 w-100"
                  ref="dataTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr @click="openDoc(props.item.id)" :key="props.item.id">
                      <td class="text-xs-center">
                        {{ props.item.docDateTime | formatDateTime }}
                      </td>
                      <td class="text-xs-center">{{ props.item.docNum }}</td>
                      <td class="text-xs-left">{{ props.item.clientName }}</td>
                      <td class="text-xs-left">
                        {{ props.item.automobileName }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div v-if="noArchivedDocuments && docsLoaded">
                      <h3 class="text-center">{{ $t('docList.noDocs') }}</h3>
                    </div>
                    <div v-else>
                      <spinner></spinner>
                    </div>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-container>
      </v-content>

      <v-dialog v-model="settingsDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('docList.listSettings') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list class="elevation-1">
              <v-checkbox
                :label="docListTexts.rememberDate"
                v-model="saveListDate"
              ></v-checkbox>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.native="settingsDialog = false">
              {{ $t('global.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios'
import router from '@/router'
import moment from 'moment'
import '@netcz/vue-pikaday'
import store from '@/services/store'
import i18n from '@/plugins/i18n'
const globalTexts = i18n.messages[i18n.locale].global

export default {
  name: 'DocList',
  components: {
    navbar: () => import('../components/Navbar.vue'),
    spinner: () => import('../components/Spinner.vue'),
    periodPicker: () => import('../components/PeriodPick.vue'),
    'input-with-vk': () => import('../components/InputWithVKeyboard.vue'),
  },
  data: function() {
    return {
      periodSelecting: false,
      datePickItems: [
        { title: globalTexts.today, val: 0 },
        { title: globalTexts.week, val: 1 },
        { title: globalTexts.prevWeek, val: 2 },
        { title: globalTexts.nextWeek, val: 3 },
        { title: globalTexts.month, val: 4 },
        { title: globalTexts.prevMonth, val: 5 },
        { title: globalTexts.period + '...', val: 6 },
      ],
      periodsHistory: [],
      docs: [],
      currentTab: 0,
      headers: [
        {
          colId: 'date',
          text: 'date',
          value: 'docDateTime',
          align: 'center',
          width: '10%',
        },
        {
          colId: 'number',
          text: 'number',
          value: 'docNum',
          align: 'center',
          width: '10%',
        },
        {
          colId: 'client',
          text: 'client',
          value: 'clientName',
          align: 'center',
          width: '30%',
        },
        {
          colId: 'automobile',
          text: 'automobile',
          value: 'automobileName',
          align: 'center',
        },
      ],
      listPeriod: { b: null, e: null },
      listPeriodOption: undefined,
      listDateOptions: {
        format: 'DD.MM.YYYY',
        i18n: {
          previousMonth: '',
          nextMonth: '',
          months: [],
          weekdays: [],
          weekdaysShort: [],
        },
        firstDay: 1,
        defaultDate: moment().toDate(),
      },
      rowsPerPage: [
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        10,
        15,
        30,
      ],
      saveListDate: false,
      noDocuments: false,
      noArchivedDocuments: false,
      momentFormats: [
        moment.ISO_8601,
        'DDMMYY',
        'DDMMYYYY',
        'YYMMDD',
        'YYYMMDD',
      ],
      settingsDialog: false,
      docSearchValue: '',
      showKeyboard: false,
    }
  },
  filters: {
    formatDateTime: val => {
      return val.format('DD.MM.YYYY HH:mm')
    },
    datePart: val => {
      return moment(val, 'DD.MM.YYYY').format('DD.MM.YYYY')
    },
    timePart: val => {
      return moment(val, 'DD.MM.YYYY HH:mm:ss').format('HH:mm')
    },
  },
  created() {
    this.initListParams()
    this.initPeriodsHistory()
    this.refreshListOptions()
  },
  mounted() {
    if (this.curDocList.length===0) {
      this.refreshList()
    }
  },
  async beforeCreate() {
    const currentTab = await this.$store.dispatch('getFormParam',{form:'DocList',key:'currentTab'})
    if (Number.isInteger(currentTab)) {
      this.currentTab = currentTab
    }
  },
  beforeDestroy() {
    this.$store.commit('setFormParam',{form:'DocList',key:'currentTab',data:this.currentTab})
  },
  methods: {
    date1C: function(d) {
      const momentDate = moment(d, this.momentFormats)
      if (momentDate.isValid()) return moment(momentDate).format('YYYYMMDD')
      else return moment().format('YYYYMMDD')
    },
    periodSelect(res) {
      if (res) {
        this.listPeriod.b = moment(res.from)
        this.listPeriod.e = moment(res.to)

        this.updatePeriodHistory()
      }
      this.periodSelecting = false
    },
    formatDate(d) {
      const momentDate = moment(d, this.momentFormats)
      if (momentDate.isValid()) return moment(momentDate).format('DD.MM.YYYY')
      else return ''
    },
    setPeriod(option) {
      this.listPeriodOption = option
      if (typeof this.listPeriodOption === 'number') {
        switch (this.listPeriodOption) {
          case 0: //today
            this.listPeriod.b = moment()
            this.listPeriod.e = this.listPeriod.b
            break
          case 1: //week
            this.listPeriod.b = moment().startOf('isoWeek')
            this.listPeriod.e = moment().endOf('isoWeek')
            break
          case 2: //prev week
            this.listPeriod.b = moment()
              .subtract(1, 'week')
              .startOf('isoWeek')
            this.listPeriod.e = moment()
              .subtract(1, 'week')
              .endOf('isoWeek')
            break
          case 3: //next week
            this.listPeriod.b = moment()
              .add(1, 'week')
              .startOf('isoWeek')
            this.listPeriod.e = moment()
              .add(1, 'week')
              .endOf('isoWeek')
            break
          case 4: //month
            this.listPeriod.b = moment().startOf('month')
            this.listPeriod.e = moment().endOf('month')
            break
          case 5: //prev month
            this.listPeriod.b = moment()
              .subtract(1, 'month')
              .startOf('month')
            this.listPeriod.e = moment()
              .subtract(1, 'month')
              .endOf('month')
            break
          case 6: //select period
            this.periodSelecting = true
            break
        }
      } else if (typeof this.listPeriodOption === 'object') {
        if (
          this.listPeriodOption.periodFrom &&
          this.listPeriodOption.periodTo
        ) {
          this.listPeriod.b = moment(
            this.listPeriodOption.periodFrom,
            this.momentFormats
          )
          this.listPeriod.e = moment(
            this.listPeriodOption.periodTo,
            this.momentFormats
          )
        }
      }

      if (this.curDocList.length===0) {
        this.refreshList()
      }
    },
    refreshListOptions() {
      this.listDateOptions.i18n.months = this.globalTexts.months.split(',')
      this.listDateOptions.i18n.weekdays = this.globalTexts.weekdays.split(',')
      this.listDateOptions.i18n.weekdaysShort = this.globalTexts.weekdaysShort.split(
        ','
      )
      this.headers.forEach(element => {
        element.text = this.globalTexts[element.colId]
      })
    },
    updatePeriodHistory() {
      this.periodsHistory.map((e, i) => {
        if (
          e.val.periodFrom === this.listPeriod.b &&
          e.val.periodTo === this.listPeriod.e
        ) {
          this.periodsHistory.splice(i, 1)
        }
      })

      this.periodsHistory.unshift({
        title: `${this.listPeriod.b.format(
          'DD.MM.YYYY'
        )} - ${this.listPeriod.e.format('DD.MM.YYYY')}`,
        val: { periodFrom: this.listPeriod.b, periodTo: this.listPeriod.e },
      })
      localStorage.periodsHistory = JSON.stringify(this.periodsHistory)
    },
    initPeriodsHistory() {
      let periodsHistory = localStorage.periodsHistory
      if (periodsHistory) {
        try {
          periodsHistory = JSON.parse(periodsHistory)
          this.periodsHistory = periodsHistory
        } catch {}
      }
    },
    initListParams() {
      this.saveListDate = localStorage.saveListDate
      if (this.saveListDate) {
        let momentDate = moment.unix(localStorage.listDateFrom)
        if (momentDate.isValid()) this.listPeriod.b = momentDate
        else this.listPeriod.b = moment()
        momentDate = moment.unix(localStorage.listDateTo)
        if (momentDate.isValid()) this.listPeriod.e = momentDate
        else this.listPeriod.e = moment()
      } else if (store.state.listPeriod) {
        this.listPeriod = store.state.listPeriod
      } else {
        this.listPeriod.b = moment().startOf('day')
        this.listPeriod.e = this.listPeriod.b.endOf('day')
      }
    },
    selectInputText() {
      document.execCommand('selectall', null, false)
    },
    setPikerReadonly() {
      this.$refs.pikaDay.$el.readOnly = true
    },
    openDoc(id) {
      router.push({ path: `/doczn/${id}` })
    },
    refreshList() {
      const archivedDocs = this.currentTab === 1
      store.dispatch('getDocList', {
        dateFrom: this.listPeriod.b,
        dateTo: this.listPeriod.e,
        archivedDocs,
      })
    },
    listSettings() {
      this.settingsDialog = true
    },
    searchByNumber() {
      if (!this.docSearchValue) return
      this.findDoc()
    },
    findDoc() {
      let params = {
        startDate: this.date1C(this.listPeriod.b),
        endDate: this.date1C(this.listPeriod.e),
      }
      if (this.docSearchValue) {
        if (!isNaN(parseInt(this.docSearchValue)) && this.docSearchValue.length===13) {
          Object.assign(params, {
            requestType: 2,
            barcode: this.docSearchValue,
          })
        } else {
          Object.assign(params, {
            requestType: 0,
            searchByNumber: true,
            searchValue: this.docSearchValue,
          })
        }
      }  else {
        return
      }

      axios
        .request({
          url: '/OrdersDetails',
          params: params,
        })
        .then(resp => {
          if (!resp.data.documents.length) {
            const message = `${this.docListTexts.docNotFound}, docSearchValue: ${this.docSearchValue}`
            this.$emit('showSnack', { color: 'error', text: message })
          } else {
            this.openDoc(resp.data.documents[0].id)
          }
        })
    },
  }, //methods
  computed: {
    docList() {
      return this.curDocList
    },
    docListArchived() {
      return this.curDocList
    },
    curDocList() {
      const archivedDocs = this.currentTab === 1
      if (!this.listPeriod.b || !this.listPeriod.e) {
        return []
      }
      let startDate = this.listPeriod.b
      let endDate = this.listPeriod.e
      const periodStr =
        startDate.startOf('day').toString() +
        '-' +
        endDate.endOf('day').toString()

      // debugger
      let list
      if (archivedDocs) {
        list = this.$store.state.docListArchived[periodStr]
      } else {
        list = this.$store.state.docList[periodStr]
      }
      return list || []
    },
    periods() {
      let res = this.datePickItems.slice()
      if (this.periodsHistory && this.periodsHistory.length) {
        res.push({ title: '-', val: -1 })
        this.periodsHistory.map((e, i) => {
          if (i < 3) {
            res.push(e)
          }
        })
      }

      return res
    },
    selectedPeriod() {
      if (this.listPeriod.b && this.listPeriod.e) {
        if (this.listPeriod.e.isSame(this.listPeriod.b)) {
          return this.formatDate(this.listPeriod.b)
        } else {
          return (
            '' +
            this.formatDate(this.listPeriod.b) +
            ' - ' +
            this.formatDate(this.listPeriod.e)
          )
        }
      }

      return this.globalTexts.pickPeriod
    },
    periodFrom() {
      if (this.listPeriod.b) {
        return this.formatDate(this.listPeriod.b)
      }
      return this.formatDate(moment())
    },
    periodTo() {
      if (this.listPeriod.e) {
        return this.formatDate(this.listPeriod.e)
      }
      return this.formatDate(moment())
    },
    docListTexts: function() {
      return i18n.messages[i18n.locale].docList
    },
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    goodsIsLoaded: function() {
      return store.state.goodsIsLoaded
    },
    docsLoaded() {
      return store.state.docsLoaded
    },
    arcDocsSupport() {
      return store.state.arcDocs
    },
  },
  watch: {

    currentTab(val) {
      if (this.curDocList.length===0) {
        this.refreshList()
      }
    },
    saveListDate(val) {
      localStorage.saveListDate = val ? '1' : ''
    },
    listPeriod() {
      if (this.saveListDate) {
        localStorage.listDateFrom = moment(this.listPeriod.b).unix()
        localStorage.listDateTo = moment(this.listPeriod.e).unix()
      }
    },
    docList(newVal) {
      if (newVal && Array.isArray(newVal)) {
        this.noDocuments = !newVal.length
      }
    },
    docListArchived(newVal) {
      if (newVal && Array.isArray(newVal)) {
        this.noArchivedDocuments = !newVal.length
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/breakpoints';

h3 {
  font-size: 18px;
  white-space: nowrap;
  @include sm {
    font-size: 15px;
  }
}
/deep/.v-list {
  a {
    text-decoration: none;
    &:hover {
      color: #fff;
    }
  }
  .hr {
    display: block;
    height: 1px;
    background: #fff;
    a {
      display: none;
    }
  }
}
.elevation-1 /deep/ {
  .v-table__overflow tr {
    background: #424242;
    th,
    td {
      &:first-child {
        padding-left: 15px !important;
      }
      &:last-child {
        padding-right: 15px !important;
      }
    }
  }
  .v-datatable__actions {
    padding-left: 15px;
    padding-right: 15px;
  }
}

/deep/.v-tabs {
  &.no-arc-docs {
    .v-tabs__bar {
      display: none;
    }
  }
}
.v-input {
  margin-top: 0 !important;
}

.action-panel {
  display: flex;
  align-items: center;
  position: relative;
  max-height: 45px;
  overflow: hidden;
  /deep/ {
    .v-input.v-text-field {
      position: relative;
      .v-label {
        line-height: 1;
        margin: 0;
        top: 15px;
        height: auto;
      }
    }
    .v-btn {
      @include sm {
        padding: 0 5px;
        max-width: 50px;
        min-width: auto;
      }
      @include xs {
        height: 30px;
      }
      i {
        @include xs {
          font-size: 18px;
        }
      }
    }
  }
}

.search-holder {
  margin-top: 4px;
}

.datepicker__wrapper {
  width: auto;
}

.col-doc-date {
  display: flex;
  flex-direction: column;
}

.cdd- {
  &date {
  }
  &time {
    font-size: 1em;
  }
}

/deep/ .column {
  @include sm {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

.day-date-title {
  flex-shrink: 0;
  margin: 0 5px 0 0;
}

.absolute-center {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.datepicker-holder {
  display: inline-flex;
}

/deep/.a-lh-1 {
  a {
    line-height: 1 !important;
  }
}
/deep/.lh-1 {
  line-height: 1 !important;
}
</style>
